import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import Editor from "@toast-ui/editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import codeSyntaxHighlight from "@toast-ui/editor-plugin-code-syntax-highlight/dist/toastui-editor-plugin-code-syntax-highlight-all";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'UiToastEditorWrapper',
  props: {
  modelValue: { type: String, required: false, default: "" },
  placeholder: { type: String, default: "", required: false },
  initialValue: { type: String, default: "", required: false },
  height: { type: String, default: "500px", required: false },
  noneClickable: { type: Boolean, default: false, required: false },
},
  emits: ["update:modelValue", "stillTyping", "stoppedTyping"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const editor = ref();
const viewer = ref();
const i18n = useI18n();
let markdownText = "";

function getMarkdownText(text: string) {
  markdownText = text;
  emit("stillTyping", { text: text });
}

onMounted(() => {
  if (props.noneClickable) {
    Editor.factory({
      el: viewer.value,
      viewer: true,
      minHeight: "200px",
      initialValue: props.initialValue ?? "",
    });
  } else {
    const e = new Editor({
      autofocus: false,
      height: props.height,
      minHeight: "200px",
      language: i18n.locale.value,
      useCommandShortcut: true,
      usageStatistics: true,
      hideModeSwitch: false,
      placeholder: props.placeholder,
      extendedAutolinks: true,
      toolbarItems: [
        ["heading", "bold", "italic", "strike"],
        ["hr", "quote"],
        ["ul", "ol", "task", "indent", "outdent"],
        ["table", "image", "link"],
        ["code", "codeblock"],
        ["scrollSync"],
      ],
      plugins: [codeSyntaxHighlight],
      el: editor.value,
      initialEditType: "wysiwyg",
      initialValue: props.initialValue ?? "",
      previewStyle: "vertical",
      events: {
        blur: () => emit("update:modelValue", e.getMarkdown()),
        change: () => getMarkdownText(e.getMarkdown()),
      },
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "editor",
      ref: editor
    }, null, 512), [
      [_directive_debounce, () => emit('stoppedTyping', { description: _unref(markdownText) }), "1s"]
    ]),
    _createElementVNode("div", {
      ref_key: "viewer",
      ref: viewer
    }, null, 512)
  ]))
}
}

})